import { useScrollSync } from '../../../../../hooks';
import { LoadingTable } from '../../../../../components';

import { PriceCell, PriceType } from '../PriceCell';
import { SalesCell } from '../SalesCell';

import { SummaryTableProps } from './SummaryTable.types.ts';
import './SummaryTable.css';
import { useMemo } from 'react';

export function SummaryTable({
  summaryData,
  fuelTypes,
  hideDiscounts,
  formatPrice,
  priceType,
  summaryFetching,
  isMobile = false,
  hideSales = false
}: SummaryTableProps) {
  const { headerRef, bodyRef } = useScrollSync();
  const { okkoData, competitors } = useMemo(() => {
    const reference = summaryData.find((b: any) => b.is_reference);
    const comps = summaryData.filter((b: any) => !b.is_reference);
    return { okkoData: reference, competitors: comps };
  }, [summaryData]);

  if (summaryFetching) {
    return <LoadingTable message="Завантаження цін..." rows={10} columns={15} />;
  }
  return (
    <div className="summary-scroll-container">
      <div className="summary-table-header-wrapper" ref={headerRef}>
        <div className="summary-table-header">
          <div className="summary-table-header-row">
            <div className={`summary-header-cell ${hideSales ? 'pricing-col-brand-wide' : 'pricing-col-brand'}`}>Бренд</div>
            {!hideSales && <div className="summary-header-cell pricing-col-sales">Реалізація л/доб.</div>}
            {fuelTypes.map(fuel => (
              <div key={fuel} className="summary-header-cell pricing-col-fuel">
                <div className="fuel-name">{fuel}</div>
                {!hideDiscounts && (
                  <div className="fuel-subheaders">
                    <div className="subheader">{priceType === PriceType.MODE ? 'Мода' : 'Середня'}</div>
                    <div className="subheader">Знижка</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="summary-table-body-wrapper" ref={bodyRef}>
        <table className={`pricing-table ${isMobile ? 'mobile-table' : ''}`}>
          <colgroup>
            <col className={hideSales ? 'pricing-col-brand-wide' : 'pricing-col-brand'} />
            {!hideSales && <col className="pricing-col-sales" />}
            {fuelTypes.map(fuel => (
              <col key={fuel} className="pricing-col-fuel" />
            ))}
          </colgroup>
          <thead className="summary-thead-hidden">
            <tr className="header-row">
              <th className={`header-cell ${hideSales ? 'pricing-col-brand-wide' : 'pricing-col-brand'}`}>Бренд</th>
              {!hideSales && <th className="header-cell pricing-col-sales">Реалізація л/доб.</th>}
              {fuelTypes.map(fuel => (
                <th key={fuel} className="header-cell pricing-col-fuel">
                  <div className="fuel-name">{fuel}</div>
                  {!hideDiscounts && (
                    <div className="fuel-subheaders">
                      <div className="subheader">{priceType === PriceType.MODE ? 'Мода' : 'Середня'}</div>
                      <div className="subheader">Знижка</div>
                    </div>
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {okkoData && (
              <tr key={okkoData.brandId} className="data-row okko-row">
                <td className="data-cell brand-cell">
                  <span className="brand-name">{okkoData.brand}</span>
                </td>
                {!hideSales && (
                  <td className="data-cell sales-cell">
                    <SalesCell sales={okkoData.sales} />
                  </td>
                )}
                {fuelTypes.map(fuel => (
                  <td key={fuel} className="data-cell price-cell">
                    <PriceCell
                      brand={okkoData}
                      fuelType={fuel}
                      hideDiscounts={hideDiscounts}
                      priceType={priceType}
                      formatPrice={formatPrice}
                      hideSales={hideSales}
                    />
                  </td>
                ))}
              </tr>
            )}

            {competitors.map((competitor: any) => (
              <tr key={competitor.brandId} className="data-row competitor-row">
                <td className="data-cell brand-cell-span" colSpan={hideSales ? 1 : 2}>
                  <span className="brand-name">{competitor.brand}</span>
                  <span className="station-count">
                    <span
                      className={`active-count ${
                        competitor.stationCounts.changeWithPrices === 'increase'
                          ? 'count-increased'
                          : competitor.stationCounts.changeWithPrices === 'decrease'
                            ? 'count-decreased'
                            : ''
                      }`}
                    >
                      {competitor.stationCounts.withPrices}
                    </span>
                    /
                    <span
                      className={`total-count ${
                        competitor.stationCounts.changeTotal === 'increase'
                          ? 'count-increased'
                          : competitor.stationCounts.changeTotal === 'decrease'
                            ? 'count-decreased'
                            : ''
                      }`}
                    >
                      {competitor.stationCounts.total}
                    </span>
                  </span>
                </td>
                {fuelTypes.map(fuel => (
                  <td key={fuel} className="data-cell price-cell">
                    <PriceCell
                      brand={competitor}
                      fuelType={fuel}
                      priceType={priceType}
                      hideDiscounts={hideDiscounts}
                      formatPrice={formatPrice}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
